import { render, staticRenderFns } from "./VeJwCjZfModal.vue?vue&type=template&id=823fc61c"
import script from "./VeJwCjZfModal.vue?vue&type=script&lang=js"
export * from "./VeJwCjZfModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports